import { Link } from "react-router-dom";
import BurgerMenu from "../../../../components/header/BurgerMenu";
import brandLeft from "../../../../assets/rizdvoniki/brand-left.png";
import brandRight from "../../../../assets/rizdvoniki/brand-right.png";

const Header = () => {
  return (
    <>
      <div className="MOBILE-MENU sm:hidden flex justify-center items-center w-screen pt-3 max-h-[60px] z-50 bg-white">
        <BurgerMenu />
      </div>
      <div className="DESKTOP-MENU hidden sm:block w-full md:max-w-[1000px] md:px-5 bg-white ">
        <div className="flex w-full justify-between items-center">
          <div className="flex justify-between items-center w-full min-h-[60px] ">
            <div className=" flex justify-center items-center md:pr-10">
              <Link to="https://radio.silpo.ua/">
                <div>
                  <img className="w-full h-[44px]" src={brandLeft} alt="img" />
                </div>
              </Link>
            </div>
            <nav className="flex justify-end">
              <ul className="space-x-6 sm:flex">
                <li className="flex flex-row items-center h-11 focus:outline-none hover:bg-lightGray cursor-pointer">
                  <Link to="https://radio.silpo.ua/">
                    <span className="rounded-md px-2 py-1 text-sm font-semibold tracking-wide truncate hover:bg-black hover:bg-opacity-[4%] hover:bg-opacity-30 transition-all duration-100 hover:-translate-y-[1px]">
                      Головна
                    </span>
                  </Link>
                </li>

                <li className="flex flex-row items-center h-11 focus:outline-none hover:bg-lightGray cursor-pointer">
                  <Link to="https://shop.silpo.ua/" target="_blank">
                    <span className="rounded-md px-2 py-1 text-sm font-semibold tracking-wide truncate hover:bg-black hover:bg-opacity-[4%] hover:bg-opacity-30 transition-all duration-100 hover:-translate-y-[1px]">
                      Онлайн-супермаркет
                    </span>
                  </Link>
                </li>
              </ul>
            </nav>
            <div>
              <img className="w-full h-[44px]" src={brandRight} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Header;
